module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "match-manage"
  }, [_c('header', {
    staticClass: "page-header"
  }, [_c('h2', {
    staticClass: "page-header__title"
  }, [_vm._v("赛事管理")]), _vm._v(" "), _c('div', {
    staticClass: "page-header__toolbar"
  }, [_c('span', {
    staticClass: "switch-text"
  }, [_vm._v("赛事菜单开关")]), _vm._v(" "), _c('el-switch', {
    staticClass: "menu-switch",
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-color": "#409EFF",
      "off-color": "#dcdfe6",
      "disabled": _vm.menuSwitchLoading
    },
    on: {
      "change": _vm.handleMenuSwitchChange
    },
    model: {
      value: (_vm.menuSwitch),
      callback: function($$v) {
        _vm.menuSwitch = $$v
      },
      expression: "menuSwitch"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-text"
  }, [_vm._v("开启后APP端将展示赛事列表")])], 1)]), _vm._v(" "), _c('el-form', {
    staticClass: "search-form",
    attrs: {
      "inline": true,
      "model": _vm.queryForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "赛事ID"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "ID精确搜索",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleQuery.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryForm.matchId),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "matchId", $$v)
      },
      expression: "queryForm.matchId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "赛事名称"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "名称模糊搜索",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleQuery.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryForm.titleKeyword),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "titleKeyword", $$v)
      },
      expression: "queryForm.titleKeyword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "赛事状态"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "全部"
    },
    model: {
      value: (_vm.queryForm.status),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "status", $$v)
      },
      expression: "queryForm.status"
    }
  }, _vm._l((_vm.competitionListStatusOptions), function(opt) {
    return _c('el-option', {
      key: opt.value,
      attrs: {
        "label": opt.label,
        "value": opt.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.resetQuery
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleQuery
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("增加赛事")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "赛事ID",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "赛事标题",
      "align": "center",
      "min-width": "160",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "报名时间",
      "align": "center",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.signStartTime) + " — " + _vm._s(row.signEndTime))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "比赛时间",
      "align": "center",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.matchStartTime) + " — " + _vm._s(row.matchEndTime))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "赛事状态",
      "align": "center",
      "width": "96"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', {
          class: _vm.statusClass(row.status)
        }, [_vm._v(_vm._s(_vm.statusText(row.status)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "viewCount",
      "label": "浏览人数",
      "align": "center",
      "min-width": "120",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "shareCount",
      "label": "分享人数",
      "align": "center",
      "min-width": "120",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "signUpCount",
      "label": "实际报名人数",
      "align": "center",
      "min-width": "120",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "virtualParticipantInitCount",
      "label": "初始虚拟人数",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "virtualParticipantMultiplier",
      "label": "虚拟倍数",
      "align": "center",
      "min-width": "120",
      "sortable": "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(+(+row.virtualParticipantMultiplier / 100).toFixed(2)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "displayRegisterCount",
      "label": "显示总人数",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "income",
      "label": "赛事收入",
      "align": "center",
      "min-width": "130",
      "sortable": "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.income) + "元")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "创建时间",
      "align": "center",
      "min-width": "165",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "align": "center",
      "width": "340"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.status === 0 || row.status === 5) ? [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handlePreview(row)
            }
          }
        }, [_vm._v("预览")])] : [(row.status === 2 || row.status === 1) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(row, row.status === 2 ? '-1' : '')
            }
          }
        }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDetail(row)
            }
          }
        }, [_vm._v("查看详情")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleInventory(row)
            }
          }
        }, [_vm._v("查看库存")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handlePrizeRecord(row)
            }
          }
        }, [_vm._v("奖品记录")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleSignUpRecord(row)
            }
          }
        }, [_vm._v("报名记录")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleCopyLink(row)
            }
          }
        }, [_vm._v("复制链接")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleCopyMatch(row)
            }
          }
        }, [_vm._v("复制赛事")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleConfigVirtual(row)
            }
          }
        }, [_vm._v("配置虚拟人数")]), _vm._v(" "), (row.status !== 4) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleOffline(row)
            }
          }
        }, [_vm._v("下架")]) : _vm._e()]]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.queryForm.pageNum,
      "page-size": _vm.queryForm.pageSize,
      "layout": "prev, pager, next, jumper",
      "total": _vm.tableTotal
    },
    on: {
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryForm, "pageNum", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryForm, "pageNum", $event)
      },
      "current-change": _vm.handleCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "custom-class": "preview-link-dialog",
      "close-on-click-modal": false,
      "modal-append-to-body": false,
      "show-close": false
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.previewDialogVisible = false
            }
          }
        }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.publishConfirmVisible = true
            }
          }
        }, [_vm._v("正式发布")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.previewDialogVisible),
      callback: function($$v) {
        _vm.previewDialogVisible = $$v
      },
      expression: "previewDialogVisible"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "preview-link-dialog__title"
  }, [_vm._v("赛事预览链接")])]), _vm._v(" "), _c('div', {
    staticClass: "preview-link-content"
  }, [_c('p', {
    staticClass: "preview-link-desc"
  }, [_vm._v("复制链接，在手机浏览器打开查看H5详情页")]), _vm._v(" "), _c('div', {
    staticClass: "preview-link-row"
  }, [_c('el-input', {
    staticClass: "preview-link-input",
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.previewUrl),
      callback: function($$v) {
        _vm.previewUrl = $$v
      },
      expression: "previewUrl"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "preview-copy-btn",
    on: {
      "click": _vm.copyPreviewUrl
    }
  }, [_vm._v("复制")])], 1), _vm._v(" "), _c('p', {
    staticClass: "preview-link-tip"
  }, [_vm._v("\n        提示：预览链接仅用于核对页面，无法进行报名操作\n      ")])])], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "custom-class": "publish-confirm-dialog",
      "close-on-click-modal": false,
      "modal-append-to-body": false,
      "show-close": false
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.publishConfirmVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.handlePublish
          }
        }, [_vm._v("确定发布")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.publishConfirmVisible),
      callback: function($$v) {
        _vm.publishConfirmVisible = $$v
      },
      expression: "publishConfirmVisible"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "publish-confirm-dialog__title"
  }, [_vm._v("正式发布确认")])]), _vm._v(" "), _c('div', {
    staticClass: "publish-confirm-content"
  }, [_c('p', {
    staticClass: "publish-confirm-desc"
  }, [_vm._v("\n        确认正式发布该赛事？发布后将同步到APP端，所有用户可见并可报名。\n      ")])])], 2), _vm._v(" "), _c('inventory-dialog', {
    attrs: {
      "visible": _vm.inventoryDialogVisible,
      "match-id": _vm.inventoryMatchId
    },
    on: {
      "update:visible": function($event) {
        _vm.inventoryDialogVisible = $event
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "custom-class": "offline-confirm-dialog",
      "close-on-click-modal": false,
      "modal-append-to-body": false,
      "show-close": false
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.offlineDialogVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.confirmOffline
          }
        }, [_vm._v("确定")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.offlineDialogVisible),
      callback: function($$v) {
        _vm.offlineDialogVisible = $$v
      },
      expression: "offlineDialogVisible"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "offline-confirm-dialog__title"
  }, [_vm._v("下架确认")])]), _vm._v(" "), _c('div', {
    staticClass: "offline-dialog-content offline-dialog-content--fit"
  }, [_c('p', {
    staticClass: "offline-title"
  }, [_vm._v("确认下架该赛事吗？")]), _vm._v(" "), _c('div', {
    staticClass: "offline-rules"
  }, [_c('p', [_vm._v("1. 前台将隐藏赛事，不再接受新用户报名")]), _vm._v(" "), _c('p', [_vm._v("2. 已报名用户不受影响，可正常完赛、领取奖励")]), _vm._v(" "), _c('p', [_vm._v("3. 正式H5链接仍可访问，但无法报名")])])])], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "custom-class": "virtual-count-dialog",
      "close-on-click-modal": false,
      "modal-append-to-body": false,
      "show-close": false
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.virtualDialogVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.virtualSaving
          },
          on: {
            "click": _vm.saveVirtualConfig
          }
        }, [_vm._v("保存配置")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.virtualDialogVisible),
      callback: function($$v) {
        _vm.virtualDialogVisible = $$v
      },
      expression: "virtualDialogVisible"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "virtual-count-dialog__title"
  }, [_vm._v("配置虚拟人数比例")])]), _vm._v(" "), _c('div', {
    staticClass: "virtual-count-content"
  }, [_c('div', {
    staticClass: "virtual-count-row",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('span', {
    staticClass: "virtual-count-label"
  }, [_vm._v("初始虚拟人数：")]), _vm._v(" "), _c('el-input', {
    staticClass: "virtual-count-input",
    attrs: {
      "placeholder": "填写基础虚拟人数"
    },
    on: {
      "change": _vm.filterVirtualInitCount
    },
    model: {
      value: (_vm.virtualParticipantInitCount),
      callback: function($$v) {
        _vm.virtualParticipantInitCount = $$v
      },
      expression: "virtualParticipantInitCount"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "virtual-count-content"
  }, [_c('div', {
    staticClass: "virtual-count-row"
  }, [_c('span', {
    staticClass: "virtual-count-label"
  }, [_vm._v("显示人数倍数：")]), _vm._v(" "), _c('el-input', {
    staticClass: "virtual-count-input",
    attrs: {
      "placeholder": "建议1-5倍"
    },
    model: {
      value: (_vm.virtualMultiple),
      callback: function($$v) {
        _vm.virtualMultiple = $$v
      },
      expression: "virtualMultiple"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "virtual-count-tip"
  }, [_vm._v("\n        *设置后，显示报名人数=初始虚拟人数 + 实际报名人数*倍数\n      ")])])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1f128318!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/onlineMatch/matchManage.vue
// module id = 962
// module chunks = 0